import { useMemo } from "react";
import { useTranslation } from "react-i18next";

import {
    deleteMasterAppointmentDock,
    postMasterAppointmentDock,
    updateMasterAppointmentDock,
} from "../../../../../../../../../../redux/actions/masterAppointment/appointmentBoard/appointmentDock/action";
import { useAppDispatch, useAppSelector } from "../../../../../../../../../../redux/hooks";
import {
    resetMasterAppointmentDockForm,
    setShowPopUpAppointmentDock,
} from "../../../../../../../../../../redux/reducers/masterAppointment/appointmentBoard/appointmentDock/form";
import { PopUpConfirmation } from "../../../../../../../../../common/popup/popUpConfirmation/popUpConfirmation";
import { PopUpForm } from "../../../../../../../../../common/popup/popUpForm/popUpForm";
import { MasterBoardHistoryAppointmentDockForm } from "./form/form";
import { PopUpCodes } from "../../../../../../../../../../common/enum/PopUpCodes";
import { PopUpConfirmationType } from "../../../../../../../../../../common/enum/PopUpConfirmationType";
import { RequiredFieldsMessage } from "../../../../../../../../../common/requiredMessage/requiredMessage";

export const MasterBoardHistoryAppointmentDockControllerForm = () => {
    const dispatch = useAppDispatch();
    const { showPopUp, form, loading } = useAppSelector((store) => store.masterAppointmentDockForm);
    const { id } = useAppSelector((store) => store.masterAppointmentBoardEdit.form);

    const { t } = useTranslation("common", { keyPrefix: "MASTER_APPOINTMENT.APPOINTMENT_BOARD.APPOINTMENT_CONDITIONS" });
    const onSave = () => {
        if (showPopUp === PopUpCodes.CREATE) {
            dispatch(postMasterAppointmentDock(id.toString(), form)).then((response: any) => {
                response && onClose();
            });
        } else if (showPopUp === PopUpCodes.UPDATE) {
            dispatch(updateMasterAppointmentDock(id.toString(), form.id.toString(), form)).then((response: any) => {
                response && onClose();
            });
        } else if (showPopUp === PopUpCodes.DELETE) {
            dispatch(deleteMasterAppointmentDock(id.toString(), form.id.toString()));
            onClose();
            onDimissed();
        }
    };

    const onClose = () => {
        dispatch(setShowPopUpAppointmentDock(PopUpCodes.NONE));
    };

    const onDimissed = () => {
        dispatch(resetMasterAppointmentDockForm());
    };
    const titlePopUp = useMemo(() => {
        if (showPopUp === PopUpCodes.CREATE) {
            return t("CREATE_DOCK");
        } else if (showPopUp === PopUpCodes.UPDATE) {
            return t("UPDATE_DOCK");
        }
        return "";
    }, [showPopUp]);

    const isDisabledButton = useMemo(() => {
        return !form.code || !form.description;
    }, [form]);
    return (
        <>
            <PopUpForm
                content={<MasterBoardHistoryAppointmentDockForm />}
                title={titlePopUp}
                isVisible={showPopUp === PopUpCodes.CREATE || showPopUp === PopUpCodes.UPDATE}
                onCancel={onClose}
                onSave={onSave}
                height={"30vh"}
                width={"40vh"}
                isDisabledButton={isDisabledButton}
                isLoading={loading}
                onDimissed={onDimissed}
                leftButtonContent={<RequiredFieldsMessage />}
            />

            <PopUpConfirmation
                showPopUp={showPopUp === PopUpCodes.DELETE}
                onCancel={onClose}
                onAccept={onSave}
                type={PopUpConfirmationType.DELETE}
                disabledActions={loading}
                height={"auto"}
                width={"auto"}
            ></PopUpConfirmation>
        </>
    );
};
